
import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Blocks from "./Blocks/Blocks";
import ImgSlider from "./ImgSlider/ImgSlider";
import RequestPage from "./RequestPage/RequestPage"
import style from "./Upgrade.module.css"


const Upgrade = () => {
  const onChange = (e) => {
    console.log(e);
  };
  return (
    <div className={style.upgrade}>
      <Header/>
      <div className={style.upgrade__inner}>
        <div className={style.container}>
          <h1>Upgrade your PC in PC Engine</h1>
        </div>
      </div>
      <div className={style.upgrade__scnd}>
        <div className={style.container}>
          <h2 className={style.upgrade__main}>What is Upgrade Center PC Engine?</h2>
          <p className={style.upgrade__main_desc}>The PC Engine Upgrade Center is where we transform your PC from the inside and out. Here, our experts with many years of experience will give a new “life” to your faithful steel friend: they will improve its technical characteristics, as well as make it stylish and stand out according to your desire!</p>
          <div className={style.blocks}>
            <Blocks
              title="Performance issues?"
              desc="We will replace obsolete components with new ones and increase the power of the computer." />
            <Blocks
              title="System malfunctions?"
              desc="We will carry out a complete diagnosis of the entire machine and eliminate the existing problems." />
            <Blocks
              title="Not satisfied with the look?"
              desc="Painting, vinylography, airbrushing, RGB…
            We will change the design to your taste and color." />
            <Blocks
              title="Is it take a lot of time to get to our office?"
              desc="No need to go anywhere - we will pick up and deliver the PC right to your doorstep" />
          </div>
        </div>
      </div>



      <div>
        <h1 className={style.request_tit}>Leave a request for an upgrade</h1>
        <div className={style.last_part}>
          <RequestPage />
          <ImgSlider style="width: 50%"/>
          
        </div>

      </div>


    <Footer/>
    </div>

  )
};

export default Upgrade;